import { bindable } from 'aurelia';
import { TeamGame } from './team-game';
import { EditScheduleViewModel } from './edit-schedule-view-model';
import { OpponentsViewModel } from '../../../components/schedule/opponents-view-model';
import { TeamSettingEntity } from '../../../apis/team/team-setting-entity';

export class ScheduleEditor {
    @bindable public viewModel: EditScheduleViewModel = null;
    @bindable public isEditMode: boolean = false;

    public opponentsVisible: boolean = false;
    public scheduleVisible: boolean = true;
    // "<groupId>|<team>" of the last clicked team; group is part of the key since names can repeat across groups.
    public highlightKey: string = null;

    public isEditModeChanged(newVal: boolean): void {
        this.highlightKey = null;
        if (!newVal && this.viewModel) {
            this.viewModel.selectedTeamGame = null;
            this.viewModel.selectedRemovedTeam = null;
        }
    }

    public get opponentList(): OpponentsViewModel[] {
        if (this.viewModel == null) {
            return [];
        }
        return this.viewModel.opponentList;
    }

    public get teamSettings(): TeamSettingEntity[] {
        if (this.viewModel == null) {
            return [];
        }
        return this.viewModel.teamSettings;
    }

    public highlight(teamGame: TeamGame, isHome: boolean): void {
        const team = isHome ? teamGame.homeTeam : teamGame.opponentTeam;
        if (team) {
            this.highlightKey = `${teamGame.groupId ?? ''}|${team}`;
        }
    }

    public getVenueName(teamGame: TeamGame): string {
        return teamGame.game.fieldId != null ? teamGame.game.fieldId.toString() : '';
    }
    public addTeam(team: TeamSettingEntity): void {
        this.viewModel.addExtraGame(team);

    }

    public showOpponents(): void {
        this.scheduleVisible = false;
        this.opponentsVisible = true;
    }
    public showSchedule(): void {
        this.opponentsVisible = false;
        this.scheduleVisible = true;
    }

    public onDeleteRow(_index: number): void {
        this.viewModel.deleteLastRow();
    }
    public onAddRow(): void {
        this.viewModel.addRow();
    }

}
